import { createAction, props } from '@ngrx/store';
import { BlockedIpTypes } from 'generated/graphql-types';
import { SingleGraphError } from 'src/app/common-components/errors/models/error-message';
import { createRegisterActions } from 'src/app/common-components/register/models/register-actions';
import { BannedProvisioningIpRegisterListItem } from '../models/banned-provisioning-ip-register-results.model';

const area = 'Banned Provisioning IP Register';
export const bannedProvisioningIpRegisterAdapterActions =
   createRegisterActions<BannedProvisioningIpRegisterListItem>(area);

export const refreshList = createAction(`[${area}] Refresh List`);

export const allowIp = createAction(
   `[${area}] Allow IP`,
   props<{ ipAddress: string; blockedIpType: BlockedIpTypes | null }>()
);

export const allowIpSuccess = createAction(`[${area}] Allow IP Success`, props<{ ipAddress: string }>());

export const allowIpFailure = createAction(`[${area}] Allow IP Failure`, props<SingleGraphError>());

export const unbanIp = createAction(`[${area}] Unban IP`, props<{ blockedIpAddressId: number; ipAddress: string }>());

export const unbanIpSuccess = createAction(`[${area}] Unban IP Success`, props<{ ipAddress: string }>());

export const unbanIpFailure = createAction(`[${area}] Unban IP Failure`, props<SingleGraphError>());
